import { render, staticRenderFns } from "./build.vue?vue&type=template&id=818f42a4"
import script from "./build.vue?vue&type=script&lang=js"
export * from "./build.vue?vue&type=script&lang=js"
import style0 from "./build.vue?vue&type=style&index=0&id=818f42a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports